import React, { useMemo, useRef } from 'react';
import { useController } from 'react-hook-form';
import { DatePicker } from '@/ui';

export const FormDatePicker = ({ form, ...props }) => {
  const {
    field,
    fieldState: { error }
  } = useController({
    ...form,
    defaultValue: ''
  });
  const ref = useRef();
  const { value, ...otherField } = field;

  const formatValue = useMemo(() => {
    if ((new Date(value) !== "Invalid Date") && !isNaN(new Date(value))) {
      try {
        return value && typeof value === 'string' ? new Date(value) : value;
      } catch (e) {
        return null;
      }
    } else return null;
  }, [value]);

  const today = new Date();
  let minDate = null, maxDate = null;
  if (props.question && props.question.dateForSelect) {
    if (props.question.dateForSelect === 'OLD') maxDate = today;
    if (props.question.dateForSelect === 'NEW') minDate = today;
  }
  if (props.productQuestion && props.productQuestion.dateForSelect) {
    if (props.productQuestion.dateForSelect === 'OLD') maxDate = today;
    if (props.productQuestion.dateForSelect === 'NEW') minDate = today;
  }

  return (
    <DatePicker
      selected={formatValue}
      error={error}
      showYearDropdown
      minDate={minDate}
      maxDate={maxDate}
      ref={ref}
      {...otherField}
      {...props}
    />
  );
};
